// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ffdf08d0","455":"fb805f06","977":"d3343521"}[chunkId] + ".chunk.js";
};